var _excluded = ["element"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './layout.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Layout = _ref => {
  var element = _ref.element,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(element || 'div', props);
};
Layout.propTypes = {
  element: PropTypes.string
};
Layout.defaultProps = {
  element: 'div'
};
export var BodySection = props => ___EmotionJSX(Layout, _extends({
  element: "section",
  css: styles.bodySection
}, props));
export var PageContainer = props => ___EmotionJSX(Layout, _extends({
  element: "section",
  css: styles.pageContainer
}, props));
export var FullWidth = props => ___EmotionJSX(Layout, _extends({
  css: styles.fullWidth
}, props));